<template>
  <div class="empty-teacher-list-row">
    <div
      class="first-row d-flex justify-content-start align-items-start nowrap"
    >
      <!-- TEACHER AVATAR -->
      <div class="avatar border_grey_light_bg">
        <span class="flex-center icon-teacher font-19 border_grey_dark"></span>
      </div>

      <!-- INFO TEXT -->
      <div class="info-text color_ash font-12">
        No teacher has been assigned to this class yet.
      </div>
    </div>
    <div class="second-row">
      <div class="add-new-item pointer">
        <div class="undone"></div>
        <div
          class="label-text font-weight-bold brand_accent"
          @click="$emit('toggleTeacher')"
        >
          Invite Teachers
        </div>
      </div>
      <div
        class="card c-tour-extra-desc-2"
        v-if="getTour.current_number == 3 && startTour"
      >
        <span class="c-tour-extra-desc-span"></span>
        <span class="c-tour-extra-desc-span-2" @click="nextTour(0)">x</span>
        <div class="row p-3">
          <div class="col-12">
            <p>
              <small style="size: 12px; line-height: 19.8px;"
                >Nothing really happens without the teacher. 👩‍ 🏫 Add teachers
                to class</small
              >
            </p>
          </div>
          <div class="col-12 d-flex mt-3 justify-content-between">
            <button
              class="btn btn-sm btn-secondary c-f-10"
              @click="nextTour(4)"
            >
              Skip
            </button>
            <button
              class="btn btn-sm btn-primary c-f-10"
              @click="$emit('toggleTeacher')"
            >
              Add Teachers
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "MembersEmptyTeacherList",
  computed: {
    ...mapGetters(["getTour", "startTour"]),
  },
  methods: {
    ...mapActions(["nextTour"]),
  },
};
</script>

<style lang="scss">
.c-f-10 {
  font-size: 10px !important;
}
.c-tour-extra-desc-2 {
  position: absolute;
  z-index: 130;
  width: 19rem;
  left: 1rem;
  top: 2rem;
  background: #f5f5f5;
}
.c-tour-extra-desc-span-2 {
  position: absolute;
  display: flex;
  /* content: ""; */
  width: 1.5rem;
  height: 1.5rem;
  background: #f5f5f5;
  top: -0.5rem;
  right: -0.5rem;
  padding: 0.2rem;
  border-radius: 10rem;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  color: white;
  background: #2b4f77;
  box-shadow: 0px 0px 9px;
  cursor: pointer;
}

.empty-teacher-list-row {
  .first-row {
    margin-bottom: 10px;
    .avatar {
      margin-right: 10px;
    }
  }

  .second-row {
    position: relative;
    top: -10px;
    .add-new-item {
      width: 100%;
    }
  }
}
</style>
